import React from 'react';
import { COLORS } from 'Permafrost/index';
import { StyledFlag } from './Flag.styles';
export const Flag = (props) => {
    const { id, className, text, flagColor = COLORS.yellowOrange, fontColor = COLORS.black } = props;
    return (React.createElement(StyledFlag, { id: id, className: className, "data-cy": props['data-cy'], "data-testid": "flag-component", "$flagColor": flagColor, "$fontColor": fontColor }, text));
};
//# sourceMappingURL=Flag.js.map